import(/* webpackMode: "eager" */ "/var/www/vhosts/codeschnipsel.dev/httpdocs/codeschnipsel-monorepo/apps/nextjs-site/app/HomePageClient.jsx")